import { render, staticRenderFns } from "./Status.vue?vue&type=template&id=52906359&"
import script from "./Status.vue?vue&type=script&lang=ts&"
export * from "./Status.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports